import { isIsrael } from "../../../../common-deprecated/settings/utils/commonSettingUtils";

// Some units should always be positioned LTR, also for Israel
export const calculateUnitPosition = (
    cultureName: string,
    value?: string,
    unit?: string,
    returnDashIfNoValue: boolean = false, // This is currently only true for the cross model compare.
): string => {
    const israel = isIsrael(cultureName);
    if (!value && returnDashIfNoValue) return "-";
    if (israel && unit === "°") return `${unit} ${value ?? ""}`;
    return `${value ?? ""} ${unit ?? ""}`;
};
